module.exports = __webpack_public_path__ + "img/slide9.cdcfc331.jpg";